module.exports = __webpack_public_path__ + "static/jianbian-line.97498194.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/jianbian-line.png
// module id = 1026
// module chunks = 2